// Page options → Payments (Figma 2745:1977): coming soon in step 1 (payments are step 6).
import { useTranslation } from "react-i18next";
import { Banknote } from "lucide-react";
import PersonalModal from "./PersonalModal";

export default function PaymentsModal({ onClose }: { onClose(): void }) {
  const { t } = useTranslation();
  return (
    <PersonalModal title={t("personal_payments", "Payments")} testId="payments-modal" onClose={onClose}>
      <div className="flex flex-col items-center gap-2 px-6 pt-8 pb-12 text-center">
        <Banknote size={40} aria-hidden="true" className="text-[var(--foreground-subtle)]" />
        <strong className="text-base font-bold text-[var(--foreground)]">{t("personal_payments_soon_title", "Payments are coming soon")}</strong>
        <span className="text-sm text-[var(--foreground-muted)]">
          {t("personal_payments_soon_body", "You will pay for Apopilo stays and Books here.")}
        </span>
      </div>
    </PersonalModal>
  );
}
